

/* global angular */

/** @TopControlsStore */
const TopControlsStore = function ($location, ResourceHelper, Flux, TopControlsActions, NavActions, SiteSelectorActions, APP_DISPATCHER_ID, AnalyticsService) {

  const DataCaptureStore = Flux.Store.get('DataCaptureStore'),
    SiteStore = Flux.Store.get('SiteStore'),

    TopControlsStore = Flux.Store.create({
      name: 'TopControlsStore',
      events: {
        Changed: true,
        ShowPopup: true,
        ChangedMap: true
      }
    });

  //null initial state
  TopControlsStore.$state = {
    disablePointCloudMap : true,
    disableMeshMap: true,
    disableNewest : true,
    showWebglMap : false,
    currentLayerType : 'tileLayer',
    destination: ''
  };

  TopControlsStore.init = function init() {
    var dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(TopControlsActions.ToggleWebglMap, this._handleToggleWebglMap.bind(this));
    dispatcher.register(SiteSelectorActions.SiteSelected, this._handleSiteSelected.bind(this));
    dispatcher.register(TopControlsActions.ChangeNavigationWhileDisabled, this._handleChangeNavigationWhileDisabled.bind(this));
    dispatcher.register(TopControlsActions.ContinueWithNavigation, this._handleContinueWithNavigation.bind(this));
    dispatcher.register(TopControlsActions.ChangeCurrentLayerType, this._handleChangeCurrentLayerType.bind(this));
    dispatcher.register(TopControlsActions.ToggleMapboxGL, this._handleToggleMapboxGL.bind(this));
  }.bind(this);

  this._handleChangeCurrentLayerType = (ev) => {

    angular.extend(TopControlsStore.$state, {
      currentLayerType : ev.data
    });
  };

  this._handleToggleMapboxGL = (ev) => {

    angular.extend(TopControlsStore.$state, {
      useMapboxGL: ev.enabled
    });

    TopControlsStore.emit(TopControlsStore.Events.Changed);
    TopControlsStore.emit(TopControlsStore.Events.ChangedMap);
  };

  this._handleSiteSelected = () => {

    angular.extend(TopControlsStore.$state, {
      showWebglMap : false,
      currentLayerType : 'tileLayer'
    });

    TopControlsStore.emit(TopControlsStore.Events.Changed);
  };

  /**
  * Get the new datacapture and check if it contains 3D data in it
  */
  this._handleDataCaptureStoreChage = () => {

    const currentDataCapture = DataCaptureStore.get('current');
    // Invalid or no datacapture? do nothing
    if (!currentDataCapture){
      angular.extend(TopControlsStore.$state, {
        disablePointCloudMap : true,
        disableMeshMap: true,
        disableNewest: true,
        showWebglMap : false,
        currentLayerType : 'tileLayer'
      });
      return;
    }

    const hasPointCloudLayer = currentDataCapture.dataCaptureLayers.some((layer) => {

      return 'pc_rgb'.indexOf(layer.layerType) > -1;
    });

    const hasMeshLayer = currentDataCapture.dataCaptureLayers.some((layer) => {

      return 'mesh_gltf'.indexOf(layer.layerType) > -1;
    });

    angular.extend(TopControlsStore.$state, {
      disablePointCloudMap: !hasPointCloudLayer ,
      disableMeshMap: !hasMeshLayer,
      disableNewest: false
    });

    TopControlsStore.emit(TopControlsStore.Events.Changed);
  };

  this._handleChangeNavigationWhileDisabled = (action) => {

    TopControlsStore.emit(TopControlsStore.Events.ShowPopup);
    TopControlsStore.$set('destination', action.to);
  };

  this._handleContinueWithNavigation = () => {

    const destination = TopControlsStore.$state.destination;

    if (destination === 'siteSelector') {
      SiteSelectorActions.ShowSiteSelector.dispatch();
    }
    else {
      $location.path(destination);
    }
  };

  this._handleSiteStoreChange = () => {

    angular.extend(TopControlsStore.$state, {
      showWebglMap : false
    });

    TopControlsStore.emit(TopControlsStore.Events.Changed);
  };

  this._handleToggleWebglMap = (ev) => {

    if (ev.data) {
      const site = DataCaptureStore.get('current').site;

      AnalyticsService.track('[CORE] 3D', 'View 3D', {
        siteId: site.id,
        siteName: site.name
      });
    }

    angular.extend(TopControlsStore.$state, {
      showWebglMap: (ev.data !== 'tileLayer'),
      currentLayerType: ev.data ? ev.data : 'tileLayer'
    });

    TopControlsStore.emit(TopControlsStore.Events.Changed);
  };

  //binds to store changes
  DataCaptureStore.on(DataCaptureStore.Events.Changed, this._handleDataCaptureStoreChage.bind(this));
  SiteStore.on(SiteStore.Events.Changed, this._handleSiteStoreChange.bind(this));

  return TopControlsStore;
};

TopControlsStore.$inject = ['$location', 'ResourceHelper', 'sbFlux', 'TopControlsActions', 'NavActions', 'SiteSelectorActions', 'APP_DISPATCHER_ID', 'AnalyticsService'];

module.exports = TopControlsStore;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/TopControlsStore.js